import { ChangeDetectorRef, Component, ComponentRef, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AddToCartComponent } from '@spartacus/cart/base/components/add-to-cart';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CmsAddToCartComponent, EventService, Product, ProductScope, ProductService } from '@spartacus/core';
import { CmsComponentData, CurrentProductService, ProductListItemContext } from '@spartacus/storefront';
import { BehaviorSubject, filter, Observable, Subscription, take } from 'rxjs';
import { CheckoutAuxService } from '../../checkout/b2b/core/checkout-aux.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { isEmpty } from '../../../../core/services/simple-tools';
import { AddToCartStateService } from './add-to-cart-state.service';
@Component({
  selector: 'cx-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrl: './add-to-cart.component.scss',
  standalone: false,
})
export class CustomAddToCartComponent extends AddToCartComponent implements OnInit, OnDestroy {
  @Input() qty$?: Observable<string>;
  @Input() inProduct$?: Observable<Product>;

  override addToCartForm = this.addToCartStateService.getForm();

  showAddToCart$ = new BehaviorSubject<boolean>(false);
  showRequestaQuote$ = new BehaviorSubject<boolean>(false);
  product$ = new BehaviorSubject<Product | null | undefined>(undefined);
  isLoading$ = new BehaviorSubject<boolean>(false);
  _subscription = new Subscription();

  constructor(
    private _currentProductService: CurrentProductService,
    private _cd: ChangeDetectorRef,
    private _activeCartService: ActiveCartFacade,
    private _component: CmsComponentData<CmsAddToCartComponent>,
    private _eventService: EventService,
    private productService: ProductService,
    private checkoutAuxService: CheckoutAuxService,
    private userAccountFacade: UserAccountFacade,
    private addToCartStateService: AddToCartStateService,
    @Optional() private _productListItemContext?: ProductListItemContext,
  ) {
    super(_currentProductService, _cd, _activeCartService, _component, _eventService, _productListItemContext);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.setInitialState();
    this.checkQuanty();
    this.checkProduct();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }

  setInitialState() {
    this.isLoading$.next(true);
    this.showAddToCart$.next(false);
    this.showRequestaQuote$.next(false);
  }

  getProduct(): Observable<Product | null | undefined> {
    if (this.inProduct$) {
      return this.inProduct$;
    }

    if (this.productCode) {
      return this.productService.get(this.productCode);
    }

    return this.currentProductService.getProduct([ProductScope.DETAILS, ProductScope.PRICE]);
  }

  checkProduct() {
    this._subscription.add(
      this.getProduct().subscribe(product => {
        this.product$.next(product);
      }),
    );

    this.product$ &&
      this._subscription.add(
        this.product$.subscribe(product => {
          this.showAddToCart$.next(false);
          this.showRequestaQuote$.next(false);

          if (product?.discontinued === false) {
            const hasPrice =
              product.yourPrice?.value !== 0 &&
              product.yourPrice?.value !== null &&
              product.yourPrice?.value !== undefined;

            if (!product.thirdPartyPriceStatus?.isPristine && !product.thirdPartyPriceStatus?.isLoading) {
              hasPrice ? this.showAddToCart$.next(true) : this.showRequestaQuote$.next(true);
              this.isLoading$.next(false);
            }
          }
        }),
      );
  }

  checkQuanty() {
    if (this.qty$) {
      this._subscription.add(
        this.qty$.subscribe(qty => {
          this.addToCartForm.get(`quantity`)?.setValue(qty);
        }),
      );
    }
  }

  convertToUntypedFormControl(data: any): UntypedFormControl {
    return data;
  }

  override addToCart() {
    const quantity = this.addToCartForm.get('quantity')?.value;

    this.userAccountFacade
      .get()
      .pipe(
        take(1),
        filter(user => !isEmpty(user)),
      )
      .subscribe(user => {
        const userIsAbleToCheckout = this.checkoutAuxService.userIsAbleToCheckout(user!);
        const productCode = this.product$.getValue()?.code;

        if (!userIsAbleToCheckout) {
          this.checkoutAuxService.handlerUserNotAbleToCheckout();

          return;
        }

        if (!productCode || quantity <= 0) {
          return;
        }

        if (this.pickupOptionCompRef instanceof ComponentRef) {
          this.pickupOptionCompRef.instance.intendedPickupLocation$
            .pipe(take(1))
            .subscribe((intendedPickupLocation: any) => {
              this.pickupStore =
                intendedPickupLocation?.pickupOption === 'pickup' ? intendedPickupLocation.name : undefined;
            });
        }

        this.activeCartService
          .getEntries()
          .pipe(take(1))
          .subscribe(cartEntries => {
            const productCode = this.product$.getValue()?.code;

            if (productCode) {
              this.activeCartService.addEntry(productCode, quantity, this.pickupStore);

              this.eventService.dispatch(
                this.createCartUiEventAddToCart(productCode, quantity, cartEntries.length, this.pickupStore),
              );
            }
          });
      });
  }
}
